<template>
  <div class="status-desc">
    <div :class="{'on':stateItem.field===currentSelState}" @click="selectState(stateItem.field)" v-for="stateItem in stateList">
      <span>{{stateItem.name}}</span>
      <span>({{count[stateItem.field]}})</span>
    </div>
  </div>
</template>

<script>
  export default {
    name: "stateBall",
    data() {
      return {
        //当前选择的状态
        currentSelState:0,
        stateList:[
          {
            name:"进行中",
            field:'runingNum',
            id:0,
          },
          {
            name:"已完成",
            field:'finishNum',
            id:1,
          },
          {
            name:"我发起的",
            field:'myApplyNum',
            id:2,
          },
        ],
      }
    },
    props:{
      count:{
        type:Object,
        default(){
          return {}
        }
      }
    },
    computed: {},
    methods: {
      selectState(id){
        this.$emit("stateChange",{id})
      }
    },
    mounted() {
    }
  }
</script>

<style lang="stylus" scoped>
  @import "~common/stylus/config.styl"
  .status-desc
    display flex

    & > div
        background #f2f4f5
        border-radius 5px
        padding 7px
        font-size 12px
        color #666666
        display flex
        align-items center
        margin-left 6px
        cursor pointer
        float left
        &.on
          color #ffffff
          background themeColor
</style>



// WEBPACK FOOTER //
// src/components/service/stateBall.vue